export default __webpack_public_path__ + "static/media/heckendalheim-header-2.c8f873dd.svg";